import React, { useEffect } from "react";
import { Outlet, useSearchParams, useLocation, useNavigate } from "react-router-dom";

import Header from "../KnowledgeBaseLangingPage/Header";
import SignupBanner from "../KnowledgeBaseLangingPage/SignupBanner";
import Footer from "../KnowledgeBaseLangingPage/Footer";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getTenantSlug } from "../../../../utils";
import { getExternalKbSettings } from "../../../../store/features/getExternalKbSettings";
import { getKbGroupId, setKbGroupId } from "../../../../utils/kbGroupId";

const KnowledgeBaseLayout = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [tenantSlug, setTenantSlug] = React.useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: kbSettings, initialized } = useSelector((state) => state.externalKbSettings);

  console.log('kb', kbSettings?.data?.brand_color)
  useEffect(() => {
    const pathSlug = getTenantSlug();
    const invalidSlugs = ['category', 'search', 'view', 'kb'];

    const slug = (!invalidSlugs.includes(pathSlug) ? pathSlug : null)
      || new URLSearchParams(window.location.search).get('tenant')
      || sessionStorage.getItem('tenantSlug')
      || '';

    const groupId = searchParams.get('group_id') || getKbGroupId();
    if (groupId) setKbGroupId(groupId);

    if (slug && groupId) {
      setTenantSlug(slug);
      sessionStorage.setItem('tenantSlug', slug);
      dispatch(getExternalKbSettings({ businessName: slug, group_id: groupId }));
    } else if (slug) {
      setTenantSlug(slug);
      sessionStorage.setItem('tenantSlug', slug);
    }

    // Redirect /kb/view/* to /* on subdomains
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    if (!isLocal && location.pathname.startsWith('/kb/view')) {
      const newPath = location.pathname.replace('/kb/view', '') || '/';
      navigate(newPath + location.search, { replace: true });
    }
  }, [location.pathname, location.search, navigate, dispatch]);
  console.log('SlugName', tenantSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const isHome = searchParams.get('home') || location.pathname === '/knowledgeBase';

  const getHeaderBackgroundColor = () => {
    const pathname = location.pathname;
    const brandColor = kbSettings?.data?.brand_color || '#F7F8F9';
    const isMongoId = (str) => /^[a-f0-9]{24}$/i.test(str);

    if (pathname === '/' || pathname === '/kb/view' || pathname === '/kb/view/') {
      return brandColor;
    }
    if (
      pathname.match(/^\/category\/[^/]+$/) ||
      pathname.match(/^\/kb\/view\/category\/[^/]+$/)
    ) {
      return brandColor;
    }
    const parts = pathname.split('/');
    const lastSegment = parts[parts.length - 1];
    if (isMongoId(lastSegment)) return 'transparent';

    return brandColor;
  };

  return (
    <>
      <Box
        sx={{
          // ✅ zoom shrinks both visually AND in DOM (no leftover space like transform:scale)
          zoom: '0.8',
          width: '100%',
          bgcolor: "background.default",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mx: "auto",
            width: "100%",
            overflowX: "hidden",
          }}
        >
          <Box
            sx={{
              px: { xs: '24px', sm: '60px', md: '100px', lg: '160px', xl: '224px' },
              width: '100%',
            }}
          >
            <Header
              initialized={!tenantSlug ? true : initialized}
              key={kbSettings?.data?.logo || 'default'}
              businessName={kbSettings?.data?.business_name}
              backgroundColor={getHeaderBackgroundColor()}
              logo={kbSettings?.data?.logo}
            />
            <Outlet />
          </Box>
        </Box>
        <Box sx={{ height: "68px" }} />
      </Box>
    </>
  );
};

export default KnowledgeBaseLayout;